<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <h2 class="accessibility-only">Member Card</h2>
  <div class="member-card mb-3 mb-lg-0">
    <div class="d-flex flex-column justify-content-between h-100">
      <!--Name and ID-->
      <div class="d-flex justify-content-between">
        <div class="card-id text-start">
          <p class="mb-0 card-name font-size-18" *ngIf="memberDetails$ | async as memberDetails">
            {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
          </p>
          <div class="d-flex font-size-14">
            {{ ('member.card.id' | translate) + ' : ' + memberCard.ExternalRefNumber }}
          </div>
        </div>
        <img alt="" class="club-logo" src="assets/images/club-logo.png" draggable="false" />
      </div>

      <!--Balances-->
      <div class="d-flex flex-column mt-3 gap-2">
        <div class="card-points text-start gloss d-flex justify-content-between align-items-center" *ngIf="pointsBalance$">
          <div class="font-size-12">{{ 'member.card.points.balance' | translate }}</div>
          <div class="d-flex justify-content-center align-items-center gap-2">
            <span class="material-icons">loyalty</span>
            <label class="font-size-18 mb-0 text-heading">{{ pointsBalance$ | async | number : '1.0-0' }}</label>
          </div>
        </div>
        <ng-container *ngIf="memberCard.RetailDiscountLevel?.length > 0">
          <div class="card-id text-start d-flex justify-content-between mt-2">
            <div class="font-size-14">{{ 'member.card.retail.discount' | translate }}</div>
            <label class="font-size-14 mb-0">{{ memberCard.RetailDiscountLevel + '%' }}</label>
          </div>
        </ng-container>

        <ng-container *ngIf="memberCard.DiscountLevel?.length > 0">
          <div class="card-account-no text-start d-flex justify-content-between">
            <div class="font-size-14">{{ 'member.card.discount' | translate }}</div>
            <label class="font-size-14 mb-0">{{ memberCard.DiscountLevel + '%' }}</label>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
